import { axiosHelper } from 'Services/AxiosHelper';
import { onGetCustodyRelationModelBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';
import { OnGetCustodyRelationModel } from 'Models';

const command = 'RI.OnGetCustodyRelation';

const OnGetCustodyRelationQuery = async (params: onGetCustodyRelationModelBodyData): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default OnGetCustodyRelationQuery;
